<template>
  <component
    :is="hallComponent"
    :hall="hall"
    :poster="poster"
    :place-component="place"
    :popup-component="popup"
    :is-preview="isPreview"
    :tickets="tickets"
    :cart="cart"
    :hallCathegory="hallCathegory"
    @add-ticket-to-cart="onAddTicketToCart"
    @remove-ticket-from-cart="onRemoveTicketFromCart"
  ></component>
</template>

<script>
import MainHall from './main-hall.vue'
import RoundHall from './round-hall.vue'
import ShortParther from './short-parther.vue'
import Pitsunda from './pitsunda.vue'

export default {
  props: [
    'hallCathegory',
    'hall',
    'poster',
    'place',
    'popup',
    'isPreview',
    'tickets',
    'cart'
  ],
  emits: ['addTicketToCart', 'removeTicketFromCart'],
  methods: {
    onAddTicketToCart(e) {
      this.$emit('addTicketToCart', e)
    },

    onRemoveTicketFromCart(e) {
      this.$emit('removeTicketFromCart', e)
    }
  },
  computed: {
    hallComponent() {
      let component = null
      switch (this.hallCathegory) {
        case 'main-hall':
          component = MainHall
          break
        case 'short-parter':
        case 'mini-parter':
        case 'chamber':
          component = ShortParther
          break
        case 'round-hall':
          component = RoundHall
          break
        case 'pitsunda':
          component = Pitsunda
          break
      }
      return component
    }
  }
}
</script>
